
import BaseRadio from "@/components/base/BaseRadio.vue";
import BaseSection from "@/components/base/BaseSection.vue";
import useRoutes from "@/composables/useRoutes";
import { destinations } from "@/config/global.strings";
import { DirectionEnum, ModeOfTravelEnum } from "@/models/enums";
import { useBookingStore } from "@/store/booking";
import { useVuelidate } from "@vuelidate/core";
import { helpers } from "@vuelidate/validators";
import { computed, defineComponent } from "vue";
import TripType from "./TripType.vue";

export default defineComponent({
	components: {
		BaseRadio,
		BaseSection,
		TripType,
	},
	props: {
		disabled: Boolean
	},
	setup() {
		const bookingStore = useBookingStore();
		const {
			hasFrom,
			hasTo,
			destinationNames,
			outwardDestinations,
			returnDestinations,
			from,
			to,
			disableRoute,
		} = useRoutes();

		const rules = {
			booking: {
				leavingFrom: helpers.withMessage(
					() => "Please select where you are travelling from",
					hasFrom as any
				),
				goingTo: helpers.withMessage(
					() => "Please select where you are travelling to",
					hasTo as any
				),
			},
		};
		
		const v$ = useVuelidate(rules, { booking: bookingStore.getBooking });

		const modeOfTravel = computed(() => bookingStore.getBooking.modeOfTravel);

		return {
			DirectionEnum,
			destinations,
			destinationNames,
			outwardDestinations,
			from,
			returnDestinations,
			to,
			disableRoute,
			v$,
			ModeOfTravelEnum,
			modeOfTravel,
		};
	},
});
